import React, { useCallback, useState } from "react";
import { Row, Col, Button } from "reactstrap";

import SearchBox from "./Items/SearchBox";
import AdvancedSearch from "./Items/AdvancedSearch";
import { debounce } from "../../../../utils/Helper";
import style from "./Toolbar.module.scss";

const Toolbar = ({
  filters: rootFilter,
  setFilters: rootOnChange,
  Desktop,
  advanced,
  setAdvanced,
  discrepantCount,
  actions,
}) => {
  const [filters, setFilters] = useState(rootFilter);
  const debounceCallback = useCallback(
    debounce((nextValues) => rootOnChange(nextValues), 200),
    []
  );
  const options = ["All", "Matched", "Discrepant", "Pending Sett"];

  const changeFilterValue = (fieldName, fieldValue) => {
    const nextFilters = {
      ...filters,
      [fieldName]: fieldValue,
    };
    debounceCallback(nextFilters);
    setFilters(nextFilters);
  };

  const serverSearch = () => {
    actions.serverSearch();
  };

  const changeAdvancedValue = (name, value) => {
    setAdvanced({ ...advanced, [name]: value });
  };

  return (
    <div className={style.toolbar}>
      <Row>
        <Col md={0} lg={2} xl={2}>
          <h6 className={"h6 page-title " + style.totals}>Funds IO</h6>
          <div className="text-muted page-desc">Consolidation Report</div>
        </Col>
        <Col>
          <div>
            <SearchBox
              Desktop={Desktop}
              updateFilterValue={changeFilterValue}
              advanced={advanced}
              setAdvanced={changeAdvancedValue}
              filters={filters}
            />

            <AdvancedSearch
              open={advanced.open}
              onSearch={serverSearch}
              advanced={advanced}
              onChange={changeAdvancedValue}
            />
          </div>
        </Col>
        <Col>
          <div className={style.toggle}>
            {options.map((option) => (
              <button
                key={option}
                type="button"
                className={`${style.option} ${filters.summaryFilter === option ? style.active : ""}`}
                onClick={() => changeFilterValue("summaryFilter", option)}
              >
                {option}
                {option === "Discrepant" && discrepantCount > 0 && (
                  <span className={style.badge}>{discrepantCount}</span>
                )}
              </button>
            ))}
          </div>
        </Col>
        <Col className={style.export}>
          <Button color="primary" onClick={() => actions.downloadReport()}>
            <i className="fa fa-download"></i>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Toolbar;
